import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import cx from 'classnames';
import styles from './NoOverflowContainer.styles';

const NoOverflowContainer = ({ children, classes, withBottomPadding, hasCallInProgress, isMinimized }) => {
  let rootClass;
  if (hasCallInProgress && isMinimized) {
    rootClass = classes.withMinimizeVoiceCall;
  } else {
    rootClass = classes.root;
  }
  return <div className={cx(rootClass, withBottomPadding && classes.padding)}>{children}</div>;
};

NoOverflowContainer.propTypes = {
  classes: PropTypes.shape({}),
  withBottomPadding: PropTypes.bool,
};

NoOverflowContainer.defaultProps = {
  classes: {},
  withBottomPadding: false,
};

export default withStyles(styles)(NoOverflowContainer);
